import React, { useCallback, useEffect, useState } from "react";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import { TextInput } from "../UIkit";
import { makeStyles } from "@material-ui/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import { useSelector } from "react-redux";
import { getUserId } from "../../reducks/users/selectors";
import { doc, deleteDoc, updateDoc, increment } from "firebase/firestore";
import { db } from "../../firebase";
import { MinusIcon, PlusIcon } from "../Icons/CartIcons";
import classModules from "./CartListItem.module.scss";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { DEDUCTION } from "../../constants/deduction";
import NoImage from "../../assets/img/src/no_image.png";
const useStyles = makeStyles((theme) => ({
  list: {
    position: "relative",
    overflowX: "hidden",
    // height: 220,
    overflowY: "auto",

    // [theme.breakpoints.down("sm")]: {
    //   height: 300,
    //   overflowY: "auto",
    // },
    // [theme.breakpoints.between("sm", "md")]: {
    //   height: 300,
    //   width: 400,
    //   overflowY: "auto",
    // },
    // [theme.breakpoints.up("md")]: {
    //   height: 250,
    //   overflowY: "auto",
    //   width: 420,
    // },
  },
  image: {
    objectFit: "cover",
    margin: 16,
    height: 96,
    width: 96,
  },
  text: {
    width: "100%",
  },
  amount: {
    display: "flex",
    alignItems: "center",
  },
  productName: {
    textAlign: "Left",
    "& .MuiListItemText-primary": {
      fontSize: "0.8rem",
    },
  },
  size: {
    textAlign: "Left",
    "& .MuiListItemText-primary": {
      fontSize: "0.8rem",
    },
  },
  quantityContents: {
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
  },
  quantityButton: {
    width: 24,
    background: "transparent",
    border: "none",
    cursor: "pointer",
  },
  "quantityButton svg": {
    color: "#c2773e",
  },
  "quantityButton:hover svg": {
    color: "#617d98",
  },
  unitPrice: {
    display: "inlin-block",
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "14px",
    marginBottom: "4px",
    marginRight: "15px",
  },
  quantityOuterText: {
    // display:"flex",
    marginBottom: "6px",
    marginRight: "10px",
  },
  quantityInnerText: {
    // display:"flex",
    marginBottom: "6px",
    margin: "0 5px",
  },
  quantityCount: {
    display: "flex",
    // [theme.breakpoints.down("sm")]: {
    //   display: "flex",
    //   flexDirection: "column",
    //   alignItems: "center",
    //   justifyContent: "center",
    // },
    // [theme.breakpoints.up("sm")]: {
    //   display: "flex",
    //   flexDirection: "row",
    //   alignItems: "center",
    //   justifyContent: "center",
    // },
  },
  colorRed: {
    color: "red",
  },
}));

const CartListItem = (props) => {
  const classes = useStyles();
  // const selector =useSelector((state)=>state);
  const uid = useSelector(getUserId);
  const location = useLocation();
  console.log("path", location.pathname);

  const image =
    props.product.images && props.product.images.length > 0
      ? props.product.images[0].path
      : NoImage;
  const name = props.product.name;
  const price = Number(props.product.price).toLocaleString();
  const priceInt = Number(props.product.price);
  const size = props.product.size;
  const quantity = props.product.quantity;
  const totalPrice = Number(props.product.totalPrice).toLocaleString();
  const deductionPrice = Number(props.product.deduction_price).toLocaleString();
  const deductionName = props.product.deduction_name;
  const deductionIsvalid = props.product.deduction_is_valid;
  const deductionCorrectCount = props.product.deduction_correct_count;
  const [remarks, setRemarks] = useState(props.product.remarks || "");
  const [currentQuantity, setCurrentQuantity] = useState(
    props.product.quantity
  );
  const [currentTotalPrice, setCurrentTotalPrice] = useState(
    props.product.totalPrice
  );

  const removeProductFromCart = async (id) => {
    const cartItemRef = doc(db, "users", uid, "cart", id);
    await deleteDoc(cartItemRef);
  };

  const inputRemarks = useCallback(
    async (event) => {
      setRemarks(event.target.value);
      const productRef = doc(db, "users", uid, "cart", props.product.cartId);
      await updateDoc(productRef, { remarks: event.target.value });
      props.updateProductItem(
        event.target.value,
        currentQuantity,
        currentTotalPrice
      );
    },
    [setRemarks]
  );

  const handleIncrement = async (id) => {
    // 数量を増やす
    const newQuantity = currentQuantity + 1;
    const newTotalPrice = newQuantity * priceInt;
    setCurrentQuantity(newQuantity);
    setCurrentTotalPrice(newTotalPrice);
    props.updateProductItem(remarks, newQuantity, newTotalPrice);
    const productRef = doc(db, "users", uid, "cart", id);
    await updateDoc(productRef, {
      quantity: newQuantity,
      totalPrice: newTotalPrice,
    });
  };

  const handleDecrement = async (id) => {
    if (props.product.quantity === 1) {
      // 数量が1の場合、削除処理を実行
      await removeProductFromCart(id);
      return;
    }
    // 数量を減らす
    const newQuantity = currentQuantity - 1;
    const newTotalPrice = newQuantity * priceInt;
    setCurrentQuantity(newQuantity);
    setCurrentTotalPrice(newTotalPrice);
    //props.updateProductItem(remarks, currentQuantity, currentTotalPrice);
    props.updateProductItem(remarks, newQuantity, newTotalPrice);
    const productRef = doc(db, "users", uid, "cart", id);
    await updateDoc(productRef, {
      quantity: newQuantity,
      totalPrice: newTotalPrice,
    });
  };

  return (
    <>
      <div className={classes.list}>
        {location.pathname === "/order/confirm" && (
          <p
            className={`${classModules.deductionName} ${
              deductionName === DEDUCTION.NONE_DEDUCTION
                ? classModules.deductionRed
                : classModules.deductionGrey
            }`}
          >
            {deductionName}
          </p>
        )}
        <div className={classModules.firstLine}>
          <ListItemAvatar>
            <img className={classes.image} src={image} alt="商品画像" />
          </ListItemAvatar>
          <ListItemText
            className={classes.productName}
            primary={name}
            // secondary={"サイズ:" + size}
          />
          {!deductionIsvalid && (
            <div className={classModules.overlay}>
              <div className={classModules.main}>
                <p>会社負担できない数量が含まれています。</p>
                <p>
                  数量を<span>{deductionCorrectCount}</span>以下にしてください。
                </p>
              </div>
            </div>
          )}
        </div>
        <ListItemText className={classes.size} secondary={"サイズ:" + size} />
        <div className={classes.text}>
          <div className={classModules.totalPrice}>
            <div className={classModules.prices}>
              <p
                className={
                  location.pathname === "/order/confirm"
                    ? classModules.price
                    : classModules.priceBold
                }
              >{`￥${totalPrice}`}</p>
              {location.pathname === "/order/confirm" && (
                <p
                  className={`${classModules.deduction} ${
                    deductionName !== DEDUCTION.NONE_DEDUCTION
                      ? classModules.colorRed
                      : classModules.colorGrey
                  }`}
                >
                  <span>本人負担額</span>
                  <span>{`￥${deductionPrice}`}</span>
                </p>
              )}
            </div>
            <IconButton
              onClick={() => removeProductFromCart(props.product.cartId)}
            >
              <DeleteIcon />
            </IconButton>
          </div>
          <div
            className={`${classes.quantityContents} ${
              !deductionIsvalid ? classes.colorRed : ""
            }`}
          >
            <div className={classes.unitPrice}>{`単価:￥ ${price}`}</div>
            <div className={classes.quantityOuterText}>{`数量:`}</div>
            <div className={classes.quantityCount}>
              <button
                className={classes.quantityButton}
                onClick={() => handleDecrement(props.product.cartId)}
              >
                <MinusIcon />
              </button>
              <div className={classes.quantityInnerText}>{`${quantity}`}</div>
              <button
                className={classes.quantityButton}
                onClick={() => handleIncrement(props.product.cartId)}
              >
                <PlusIcon />
              </button>
            </div>
          </div>

          <TextInput
            fullWidth={true}
            label={"備考"}
            multiline={false}
            required={false}
            minRows={1}
            onChange={(event) => inputRemarks(event, props.product.cartId)}
            disabled={!props.isEnableRemarks}
            value={remarks}
            type={"text"}
          />
        </div>
      </div>
      <Divider />
    </>
  );
};

export default CartListItem;
